import React from "react";
import { ReactLogo } from "./ReactLogo";

function Footer() {
  return (
    <div>
      <center>
        <footer>
          <div>
            Copyright © {new Date().getFullYear()} Educación:
            https://www.icontec.org
          </div>
        </footer>
      </center>
    </div>
  );
}
export default Footer;
